<ion-card *ngIf="bid">
  <ion-item lines="none">
    <ion-label>
      <div class="flex-between-center">
        <ion-item
          lines="none"
          class="ion-no-padding"
        >
          <user-avatar-gql
            [avatar]="bid?.user?.avatar"
            [name]="bid?.user?.truncatedName"
            avatarSize="small"
          >
          </user-avatar-gql>
          <ion-label class="ion-padding-start">
            <h2>{{ bid?.user?.truncatedName }}</h2>
            <p
              style="padding-top: 0"
              class="ion-text-wrap small-text"
            >
              <ion-text
                *ngIf="bid?.user?.profile?.combinedFeedback"
                class="ion-margin-end"
              >
                <ion-icon
                  name="star"
                  size="medium"
                  color="orange-500"
                ></ion-icon>
                <span style="padding-top: 2px">{{ bid.user.profile.combinedFeedback }}</span>
              </ion-text>
              <ion-text>
                <ion-icon
                  name="location"
                  size="medium"
                ></ion-icon>
                <span>{{ bid?.distance }}</span>
              </ion-text>
            </p>
          </ion-label>
        </ion-item>
        <ion-text
          class="ion-text-end"
          color="grey-500"
        >
          <h1>{{ bid?.amount }}</h1>
          <p class="no-padding">per hour</p>
        </ion-text>
      </div>
      <ion-text *ngIf="noMsg">
        <p
          class="ion-text-wrap msg"
          [ngClass]="readMore ? '' : 'four-lines'"
        >
          {{ bid?.comment }}
        </p>
      </ion-text>
      <ion-button
        *ngIf="showViewMore"
        fill="clear"
        expand="block"
        (click)="readMore = !readMore"
      >
        View {{ readMore ? 'less' : 'more' }}
        <ion-icon
          slot="end"
          [name]="readMore ? 'chevron-up' : 'chevron-down'"
        ></ion-icon>
      </ion-button>
      <ion-grid class="no-padding">
        <ion-row>
          <ion-col size="6">
            <mable-button
              expand="block"
              category="outline"
              (onClick)="viewBidder()"
              >Profile</mable-button
            >
          </ion-col>
          <ion-col
            size="6"
            [ngSwitch]="noMsg"
          >
            <mable-button
              expand="block"
              category="purple-500"
              (onClick)="book()"
              *ngSwitchCase="true"
              >Instant book</mable-button
            >
            <app-message-button
              *ngSwitchCase="false"
              [userId]="bid?.user?.id"
              [channelUrl]="channelUrl"
            >
            </app-message-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-label>
  </ion-item>
</ion-card>
